import React, { useEffect, useState } from "react";
import { RootStateOrAny } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../index";
import { RoutingPlans } from "../../components/RoutingPlans/RoutingPlans";
import { fetchCurrenciesDic } from "../../store/slices/rtkDictionaries";
import { fetchOfferList } from "../../store/slices/offering/offering";
import loadingStatusCodes from "../../lib/const/loadingStatusCodes";
import { fetchDestinationCategories } from "../../store/slices/dicts";
import { fetchAgreements } from "../../store/slices/routingOrders/routingOrders";
import { AnyObject } from "../../lib/interfaces";
// import { fetchRousingOrderSearch } from "../../store/slices/routingOrders";

export const RoutingPlansContainer = () => {
  const dispatch = useAppDispatch();
  const { dicCurrencies, dicCurrenciesLoading } = useAppSelector((state) => state.rtkDictionaries);
  const { destinationCategories, destinationCategoriesLoading } = useAppSelector(
    (state) => state.dicts
  );
  const { tenantProperties, tenantPropertiesLoading } = useAppSelector(
    (state: RootStateOrAny) => state?.tenants
  );

  const [offerList, setOfferList] = useState<AnyObject | undefined>(undefined);

  useEffect(() => {
    dispatch(fetchCurrenciesDic());
    dispatch(fetchDestinationCategories());
  }, []);

  useEffect(() => {
    if (tenantPropertiesLoading === loadingStatusCodes.fulfilled) {
      dispatch(fetchAgreements(tenantProperties.accountId)).then((response) => {
        dispatch(fetchOfferList({ agreementId: response.payload[0]?.id })).then((response) => {
          if (Array.isArray(response.payload?.content)) {
            setOfferList(response.payload.content);
          }
        });
      });
    }
  }, [tenantProperties, tenantPropertiesLoading]);

  console.log("-------------");
  console.log("dicCurrenciesLoading", dicCurrenciesLoading);
  console.log("destinationCategoriesLoading", destinationCategoriesLoading);
  console.log("offerList", offerList);

  return (
    <>
      {dicCurrenciesLoading === loadingStatusCodes.fulfilled &&
        offerList &&
        destinationCategoriesLoading === loadingStatusCodes.fulfilled && (
          <RoutingPlans
            dicCurrencies={dicCurrencies}
            offerList={offerList}
            destinationCategories={destinationCategories}
          />
        )}
    </>
  );
};
